// Copyright (c) 2022 by Move Closer

import { VueConstructor } from 'vue'

import { VideoDriver } from '../../Video.config'

import { YouTubeVideo } from './index'

/**
 *
 * @param toTest - String which should be tested for a youtube src.
 *
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const isValidYoutubeUri = (toTest: string): boolean => {
  return RegExp('^(https?:\\/\\/)?(www\\.youtube\\.com|youtu\\.be)\\/.+$').test(toTest)
}

/**
 *
 * Extracts Id of the video from youtube url.
 *
 * @param source - youtube video source.
 *
 * @returns id - youtube video source id or empty string.
 *
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
const extractYoutubeVideoId = (source: string): string => {
  const match = source.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/)

  return (match && match[7].length === 11) ? match[7] : ''
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 * @param source - youtube source
 *
 * @returns YTEmbedUrl - generated embed url path.
 */
export const buildYouTubeVideoSrc = (source: string): YTEmbedUrl => {
  if (!source) {
    throw new Error('Source is empty')
  }

  const videoId: string = extractYoutubeVideoId(source)

  if (!videoId.length) {
    throw new Error('Video ID is empty')
  }

  return `${YT_EMBED_PREFIX}${videoId}`
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
const YT_EMBED_PREFIX = 'https://www.youtube.com/embed/'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export type YTEmbedUrl = string

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const youtubeVideoDriver: VideoDriver = {
  checkForUse (source: string): boolean {
    return isValidYoutubeUri(source)
  },
  component: YouTubeVideo as VueConstructor
}
